import React, { useEffect, Children } from 'react';
export function PrivacyPolicyPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-[#f8f8f8] text-[#1a1a2e] font-sans text-base leading-relaxed" data-id="element-4747" data-mp="31q056ygokzfn">
      {/* Top Bar */}
      <div className="bg-[#1a0647] px-5 py-3 md:px-8 flex items-center gap-3" data-id="element-4748" data-mp="2mw54wgulcig2">
        <span className="font-bold text-lg text-white tracking-wide" data-id="element-4749" data-mp="2rrkegwlkfs6o">
          Caveo
        </span>
        <div className="w-px h-4 bg-white/25" data-id="element-4750" data-mp="2e05y6xj1m53b"></div>
        <span className="text-[13px] text-white/60 tracking-widest uppercase" data-id="element-4751" data-mp="2is77cakwzfp4">
          Legal
        </span>
      </div>

      {/* Hero */}
      <div className="relative bg-gradient-to-br from-[#1a0647] via-[#2d0a7a] to-[#3a0f9e] px-5 pt-16 pb-12 md:pt-20 md:pb-16 text-center overflow-hidden" data-id="element-4752" data-mp="24547hx94cuym">
        <div className="absolute inset-0 pointer-events-none" style={{
        background: 'radial-gradient(ellipse at 70% 40%, rgba(133,40,226,0.35) 0%, transparent 65%), radial-gradient(ellipse at 20% 80%, rgba(1,206,209,0.12) 0%, transparent 55%)'
      }} data-id="element-4753" data-mp="1v34m6sr2n4pv"></div>

        <div className="relative z-10" data-id="element-4754" data-mp="24tbm5dsofpon">
          <div className="inline-block bg-[#b063ff]/20 border border-[#b063ff]/30 text-[#b063ff] text-xs font-medium tracking-widest uppercase px-4 py-1.5 rounded-full mb-5" data-id="element-4755" data-mp="24ummf3mwyfb0">
            Legal &amp; Privacy
          </div>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-[1.1] mb-4" data-id="element-4756" data-mp="1r154fn9vlan3">
            Privacy Policy
          </h1>
          <p className="text-base text-white/65 max-w-lg mx-auto mb-7" data-id="element-4757" data-mp="1m33k6z0pr5a1">
            AppEmbrace, Inc. d/b/a Caveo — plain English, no fine print.
          </p>
          <div className="flex justify-center gap-6 flex-wrap" data-id="element-4758" data-mp="1w08anb1ldmwn">
            <span className="text-[13px] text-white/50" data-id="element-4759" data-mp="1vyx4x5ol652w">
              <strong className="text-white/85 font-semibold" data-id="element-4760" data-mp="189ufhbnpn7xu">
                Effective:
              </strong>{' '}
              February 27, 2026
            </span>
            <span className="text-[13px] text-white/50" data-id="element-4761" data-mp="1szokrxbn6bsv">
              <strong className="text-white/85 font-semibold" data-id="element-4762" data-mp="1sz6rn9ka0dp6">
                Last Updated:
              </strong>{' '}
              February 2026
            </span>
          </div>
        </div>
      </div>

      {/* Body */}
      <div className="max-w-[820px] mx-auto px-5 md:px-6 pb-20" data-id="element-4763" data-mp="21u37um2eyqmj">
        {/* Intro */}
        <div className="bg-white border-l-4 border-[#01ced1] rounded-xl p-6 md:p-8 my-10 md:my-12 shadow-[0_2px_12px_rgba(26,6,71,0.07)]" data-id="element-4764" data-mp="26qbh5itxjpls">
          <p className="text-[#555577] text-[15px] mb-3 last:mb-0" data-id="element-4765" data-mp="1e25w0uyyrylf">
            At Caveo, we believe privacy should be simple and clear. We only
            collect the minimum personal information necessary to provide our
            services, and we never sell your data. This policy explains what we
            collect, why we collect it, and how we use it when you access
            JoinCaveo.com or any Caveo product or service. We've written it in
            plain English on purpose, because that's how we do everything.
          </p>
          <p className="text-[#555577] text-[15px] mb-0" data-id="element-4766" data-mp="nrvrypwdeqim">
            Questions? Email us at{' '}
            <a href="mailto:privacy@caveohq.com" className="text-[#8528e2] font-medium hover:underline" data-id="element-4767" data-mp="ituag9elez99">
              privacy@caveohq.com
            </a>{' '}
            and a real person will respond.
          </p>
        </div>

        {/* Section 1 - Who We Are */}
        <div className="mb-12" data-id="element-4768" data-mp="538q0g9hqh99">
          <div className="flex items-center gap-3.5 mb-5 pb-3.5 border-b border-[#eae6dc]" data-id="element-4769" data-mp="2uhkx3z95ap">
            <div className="w-9 h-9 rounded-full bg-[#1a0647] text-white font-bold text-sm flex items-center justify-center shrink-0" data-id="element-4770" data-mp="3r95ld10dgk5q">
              1
            </div>
            <h2 className="text-xl font-bold text-[#1a0647] leading-snug" data-id="element-4771" data-mp="3mbvncwyx306a">
              Who We Are
            </h2>
          </div>
          <p className="text-[#555577] text-[15px] leading-[1.8] mb-3.5 last:mb-0" data-id="element-4772" data-mp="1kio79lbhcejc">
            Caveo is operated by AppEmbrace, Inc., a Delaware C-Corporation
            headquartered in Oakland, California. We are the operator of
            JoinCaveo.com and all related Caveo products and services.
            References to "Caveo," "we," "us," or "our" throughout this policy
            refer to AppEmbrace, Inc.
          </p>
        </div>

        {/* Section 2 - What Information We Collect */}
        <div className="mb-12" data-id="element-4773" data-mp="19t5ujuiozc7h">
          <div className="flex items-center gap-3.5 mb-5 pb-3.5 border-b border-[#eae6dc]" data-id="element-4774" data-mp="19ruo1mxv3qco">
            <div className="w-9 h-9 rounded-full bg-[#1a0647] text-white font-bold text-sm flex items-center justify-center shrink-0" data-id="element-4775" data-mp="1eknv4hgszarx">
              2
            </div>
            <h2 className="text-xl font-bold text-[#1a0647] leading-snug" data-id="element-4776" data-mp="14tjgjiv1hrxm">
              What Information We Collect
            </h2>
          </div>
          <p className="text-[#555577] text-[15px] leading-[1.8] mb-3.5" data-id="element-4777" data-mp="qujrwb7j1d1g">
            We collect only what we need to give you a great experience.
          </p>

          <div className="my-5" data-id="element-4778" data-mp="c6t4v5f2okwg">
            <h3 className="text-[15px] font-bold text-[#8528e2] mb-2.5 uppercase tracking-[0.06em]" data-id="element-4779" data-mp="c84cjgbn2csu">
              Information We May Collect
            </h3>
            <ul className="list-none p-0 m-0 mb-3.5" data-id="element-4780" data-mp="l7r99otfaufk">
              {['Account information: your name, email address, and login credentials.', 'Technical information: device type, operating system, and browser.', 'Usage data: completion of checklists, alerts delivered, and progress scores.', 'Behavioral data: website pages and content visited, and usage of sections of the platform, to help us improve the product and user experience.', 'Household profile information: number of family members, general age ranges, and device types, used solely to personalize your experience.', 'Payment information: processed securely by third-party providers. We do not store full payment card numbers on our servers.'].map((item, i) => <li key={i} className="flex gap-3 text-[#555577] text-[15px] py-2 border-b border-[#eae6dc]/60 leading-[1.7] last:border-b-0" data-id="element-4781" data-mp="6lqrpfb0cxrs" data-mpi={i}>
                  <span className="text-[#8528e2] font-bold shrink-0 mt-px" data-id="element-4782" data-mp="fjavauwcf65k">
                    →
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="bg-gradient-to-br from-[#8528e2]/5 to-[#01ced1]/5 border border-[#8528e2]/15 rounded-xl p-5 md:p-6 my-4 text-[15px] text-[#555577] leading-[1.75]" data-id="element-4783" data-mp="padsvmq2d303">
            <strong className="text-[#1a0647] font-semibold" data-id="element-4784" data-mp="ycn46et5p0ej">
              We do not sell your data.
            </strong>{' '}
            We do not collect or store sensitive data such as credit card
            numbers, Social Security numbers, or passwords to your external
            accounts. We do not track your activity outside of the Caveo
            platform.
          </div>
        </div>

        {/* Section 3 - How We Use Your Information */}
        <div className="mb-12" data-id="element-4785" data-mp="2srtzqo7o7wq2">
          <div className="flex items-center gap-3.5 mb-5 pb-3.5 border-b border-[#eae6dc]" data-id="element-4786" data-mp="2sqiu0iuo0ewb">
            <div className="w-9 h-9 rounded-full bg-[#1a0647] text-white font-bold text-sm flex items-center justify-center shrink-0" data-id="element-4787" data-mp="2ntip4b9jxi6s">
              3
            </div>
            <h2 className="text-xl font-bold text-[#1a0647] leading-snug" data-id="element-4788" data-mp="3ggwenoax7bgv">
              How We Use Your Information
            </h2>
          </div>
          <p className="text-[#555577] text-[15px] leading-[1.8] mb-3.5" data-id="element-4789" data-mp="3bil4tdkml0yn">
            We use collected data to:
          </p>
          <ul className="list-none p-0 m-0 mb-3.5" data-id="element-4790" data-mp="36l1o870ggc3j">
            {['Provide and improve our services.', 'Personalize your experience and deliver relevant security modules and recommendations.', 'Send alerts, reminders, and important updates related to your account and household security.', 'Generate anonymized, aggregate reports for product improvement.', 'Respond to your support requests and questions.', 'Process payments for subscriptions and add-on services.'].map((item, i) => <li key={i} className="flex gap-3 text-[#555577] text-[15px] py-2 border-b border-[#eae6dc]/60 leading-[1.7] last:border-b-0" data-id="element-4791" data-mp="3h84jqg5gho8m" data-mpi={i}>
                <span className="text-[#8528e2] font-bold shrink-0 mt-px" data-id="element-4792" data-mp="dq36tsl4tnbl">
                  →
                </span>
                {item}
              </li>)}
          </ul>
          <p className="text-[#555577] text-[15px] leading-[1.8] mt-3.5 mb-0" data-id="element-4793" data-mp="3yytsyf0ocje">
            We do not use your information for advertising, and we do not allow
            third parties to advertise through Caveo products.
          </p>
        </div>

        {/* Section 4 - Data Protection */}
        <div className="mb-12" data-id="element-4794" data-mp="11fxiw7xmn7us">
          <div className="flex items-center gap-3.5 mb-5 pb-3.5 border-b border-[#eae6dc]" data-id="element-4795" data-mp="11h8nub2t6lnh">
            <div className="w-9 h-9 rounded-full bg-[#1a0647] text-white font-bold text-sm flex items-center justify-center shrink-0" data-id="element-4796" data-mp="1as4m32lctu1s">
              4
            </div>
            <h2 className="text-xl font-bold text-[#1a0647] leading-snug" data-id="element-4797" data-mp="1kipnsywbreox">
              Data Protection
            </h2>
          </div>
          <p className="text-[#555577] text-[15px] leading-[1.8] mb-3.5" data-id="element-4798" data-mp="1fmr07ditm0pk">
            As a cybersecurity company, we hold ourselves to high standards.
            Here is what that means in practice:
          </p>
          <ul className="list-none p-0 m-0 mb-3.5" data-id="element-4799" data-mp="11t9ily9p2y26">
            {['All personal data is encrypted in transit and at rest.', 'Access to personal data is limited to employees with a legitimate business need.', 'Vendors and service providers are required to follow strict security practices and are contractually bound to protect your data.', 'We conduct regular security reviews of our platform and infrastructure.'].map((item, i) => <li key={i} className="flex gap-3 text-[#555577] text-[15px] py-2 border-b border-[#eae6dc]/60 leading-[1.7] last:border-b-0" data-id="element-4800" data-mp="1bklvhndg3mqj" data-mpi={i}>
                <span className="text-[#8528e2] font-bold shrink-0 mt-px" data-id="element-4801" data-mp="11uisqvgiuuf0">
                  →
                </span>
                {item}
              </li>)}
          </ul>
          <p className="text-[#555577] text-[15px] leading-[1.8] mt-3.5 mb-0" data-id="element-4802" data-mp="xqunijfd4awx">
            We encourage you to use a strong, unique password for your Caveo
            account and to enable Multi-Factor Authentication (MFA) when
            available.
          </p>
        </div>

        {/* Section 5 - Family Plans and Multi-User Accounts */}
        <div className="mb-12" data-id="element-4803" data-mp="2i90wpp89u2kq">
          <div className="flex items-center gap-3.5 mb-5 pb-3.5 border-b border-[#eae6dc]" data-id="element-4804" data-mp="2i891ifil66uz">
            <div className="w-9 h-9 rounded-full bg-[#1a0647] text-white font-bold text-sm flex items-center justify-center shrink-0" data-id="element-4805" data-mp="2da7gvq5ihzhe">
              5
            </div>
            <h2 className="text-xl font-bold text-[#1a0647] leading-snug" data-id="element-4806" data-mp="2pri8y37j7vhe">
              Family Plans and Multi-User Accounts
            </h2>
          </div>
          <p className="text-[#555577] text-[15px] leading-[1.8] mb-3.5" data-id="element-4807" data-mp="2ulcocug3toao">
            Caveo is designed for multi-generational families. Some plans
            include multiple users under one account. Here is how we handle
            that:
          </p>
          <ul className="list-none p-0 m-0 mb-3.5" data-id="element-4808" data-mp="26uh4cjhw3xdz">
            {['Each family member has their own individual profile with their own privacy settings.', 'Sharing data with a designated Family IT Lead is always opt-in and voluntary, never automatic.', "Individual family members own their own data. No family member can access another member's data without that person's explicit consent.", 'Account administrators can view aggregate household security scores but cannot access individual activity logs or personal data without permission.'].map((item, i) => <li key={i} className="flex gap-3 text-[#555577] text-[15px] py-2 border-b border-[#eae6dc]/60 leading-[1.7] last:border-b-0" data-id="element-4809" data-mp="2xlmkqalswa40" data-mpi={i}>
                <span className="text-[#8528e2] font-bold shrink-0 mt-px" data-id="element-4810" data-mp="37ihi2q6c84gp">
                  →
                </span>
                {item}
              </li>)}
          </ul>
        </div>

        {/* Section 6 - Third-Party Sharing */}
        <div className="mb-12" data-id="element-4811" data-mp="2tigkpkpa7f5z">
          <div className="flex items-center gap-3.5 mb-5 pb-3.5 border-b border-[#eae6dc]" data-id="element-4812" data-mp="2tiq7kzf1567g">
            <div className="w-9 h-9 rounded-full bg-[#1a0647] text-white font-bold text-sm flex items-center justify-center shrink-0" data-id="element-4813" data-mp="2oqgdd76vtjzd">
              6
            </div>
            <h2 className="text-xl font-bold text-[#1a0647] leading-snug" data-id="element-4814" data-mp="1w32n1rxovmo8">
              Third-Party Sharing
            </h2>
          </div>
          <p className="text-[#555577] text-[15px] leading-[1.8] mb-3.5" data-id="element-4815" data-mp="bixkipgkmckk">
            Caveo does not share personal information with third parties without
            your consent, except as required by law. Specifically:
          </p>
          <ul className="list-none p-0 m-0 mb-3.5" data-id="element-4816" data-mp="6lf6wlrlz968">
            <li className="flex gap-3 text-[#555577] text-[15px] py-2 border-b border-[#eae6dc]/60 leading-[1.7]" data-id="element-4817" data-mp="6m7606kezp19">
              <span className="text-[#8528e2] font-bold shrink-0 mt-px" data-id="element-4818" data-mp="ubt1aixo1k3z">→</span>
              <span data-id="element-4819" data-mp="z8rvt2l8rt2p">
                <strong className="text-[#1a0647] font-semibold" data-id="element-4820" data-mp="z9bbecnf65dk">
                  Service providers:
                </strong>{' '}
                We work with vendors who help us operate the platform, including
                Supabase (authentication and database), Vercel (hosting), and
                PostHog (analytics). These vendors access data only as needed
                and are contractually required to protect it.
              </span>
            </li>
            <li className="flex gap-3 text-[#555577] text-[15px] py-2 border-b border-[#eae6dc]/60 leading-[1.7]" data-id="element-4821" data-mp="3qabymi4o5q3i">
              <span className="text-[#8528e2] font-bold shrink-0 mt-px" data-id="element-4822" data-mp="3lgzdihz781fi">→</span>
              <span data-id="element-4823" data-mp="3gkiprovwvp2y">
                <strong className="text-[#1a0647] font-semibold" data-id="element-4824" data-mp="3gk0htuzvzmf7">
                  Legal requirements:
                </strong>{' '}
                We may disclose information if required by law, court order, or
                government request, or to protect the rights, property, or
                safety of Caveo, our users, or others.
              </span>
            </li>
            <li className="flex gap-3 text-[#555577] text-[15px] py-2 border-b border-[#eae6dc]/60 leading-[1.7]" data-id="element-4825" data-mp="33jg5b40cobu">
              <span className="text-[#8528e2] font-bold shrink-0 mt-px" data-id="element-4826" data-mp="3v7ty7hwsqsyu">→</span>
              <span data-id="element-4827" data-mp="2nvuwp74x7veu">
                <strong className="text-[#1a0647] font-semibold" data-id="element-4828" data-mp="2nwd0qpxtrdxb">
                  Business transfers:
                </strong>{' '}
                In the event of a merger, acquisition, or sale of assets, user
                information may be transferred. We will notify you before any
                such transfer takes effect.
              </span>
            </li>
            <li className="flex gap-3 text-[#555577] text-[15px] py-2 border-b border-[#eae6dc]/60 leading-[1.7] last:border-b-0" data-id="element-4829" data-mp="18at0dsfiqxkq">
              <span className="text-[#8528e2] font-bold shrink-0 mt-px" data-id="element-4830" data-mp="1d3vjt7ql0qn7">→</span>
              <span data-id="element-4831" data-mp="1i0vs7pawm5hh">
                <strong className="text-[#1a0647] font-semibold" data-id="element-4832" data-mp="1i1dxtcjghw22">
                  With your consent:
                </strong>{' '}
                We will not share your information for any other purpose without
                asking you first.
              </span>
            </li>
          </ul>
        </div>

        {/* Section 7 - Your Privacy Rights */}
        <div className="mb-12" data-id="element-4833" data-mp="3sui0mk9q36hf">
          <div className="flex items-center gap-3.5 mb-5 pb-3.5 border-b border-[#eae6dc]" data-id="element-4834" data-mp="3svjgd21ooh5h">
            <div className="w-9 h-9 rounded-full bg-[#1a0647] text-white font-bold text-sm flex items-center justify-center shrink-0" data-id="element-4835" data-mp="1nxffh6cmssb">
              7
            </div>
            <h2 className="text-xl font-bold text-[#1a0647] leading-snug" data-id="element-4836" data-mp="10003m275wjy5">
              Your Privacy Rights
            </h2>
          </div>
          <p className="text-[#555577] text-[15px] leading-[1.8] mb-3.5" data-id="element-4837" data-mp="1e0aq6t1fvcdi">
            Depending on your location, you may have rights under applicable
            privacy laws such as the California Consumer Privacy Act (CCPA) or
            the General Data Protection Regulation (GDPR). These rights may
            include the ability to:
          </p>
          <ul className="list-none p-0 m-0 mb-3.5" data-id="element-4838" data-mp="1wpqwxy3pw12d">
            {['Access the personal information we hold about you.', 'Correct inaccurate or incomplete information.', 'Request deletion of your personal information.', 'Restrict or object to certain uses of your data.', 'Opt out of the sale of your personal information. (Note: Caveo does not sell personal information.)', 'Non-discrimination for exercising your privacy rights.'].map((item, i) => <li key={i} className="flex gap-3 text-[#555577] text-[15px] py-2 border-b border-[#eae6dc]/60 leading-[1.7] last:border-b-0" data-id="element-4839" data-mp="2q7dv1ajpnzya" data-mpi={i}>
                <span className="text-[#8528e2] font-bold shrink-0 mt-px" data-id="element-4840" data-mp="2g9g2iautjgzv">
                  →
                </span>
                {item}
              </li>)}
          </ul>
          <p className="text-[#555577] text-[15px] leading-[1.8] mt-3.5 mb-0" data-id="element-4841" data-mp="27c5mkc7233om">
            To exercise any of these rights, contact us at{' '}
            <a href="mailto:privacy@caveohq.com" className="text-[#8528e2] font-medium hover:underline" data-id="element-4842" data-mp="1xkjfms1r3qro">
              privacy@caveohq.com
            </a>
            . We will respond within 45 days.
          </p>
        </div>

        {/* Section 8 - Children's Privacy */}
        <div className="mb-12" data-id="element-4843" data-mp="242nuk0j3jnj0">
          <div className="flex items-center gap-3.5 mb-5 pb-3.5 border-b border-[#eae6dc]" data-id="element-4844" data-mp="241ma55g6xoom">
            <div className="w-9 h-9 rounded-full bg-[#1a0647] text-white font-bold text-sm flex items-center justify-center shrink-0" data-id="element-4845" data-mp="1z4cn1wg9xp3y">
              8
            </div>
            <h2 className="text-xl font-bold text-[#1a0647] leading-snug" data-id="element-4846" data-mp="1p5de0crljrgf">
              Children's Privacy
            </h2>
          </div>
          <p className="text-[#555577] text-[15px] leading-[1.8] mb-3.5" data-id="element-4847" data-mp="1l4tjlgyer1xz">
            Caveo supports multi-generational households, including older teens.
            We do not knowingly collect personal information from children under
            the age of 13 without verifiable parental consent. If a family plan
            includes a member under 13, the account holder is responsible for
            ensuring appropriate consent has been provided.
          </p>
          <p className="text-[#555577] text-[15px] leading-[1.8] mb-0" data-id="element-4848" data-mp="xdfo524ymq8s">
            If you believe a minor's data has been collected without proper
            consent, contact us at{' '}
            <a href="mailto:privacy@caveohq.com" className="text-[#8528e2] font-medium hover:underline" data-id="element-4849" data-mp="3d23ageo5nhlk">
              privacy@caveohq.com
            </a>{' '}
            and we will act promptly.
          </p>
        </div>

        {/* Section 9 - Cookies and Tracking */}
        <div className="mb-12" data-id="element-4850" data-mp="2pe3cousfeqxh">
          <div className="flex items-center gap-3.5 mb-5 pb-3.5 border-b border-[#eae6dc]" data-id="element-4851" data-mp="2pev742aaeim6">
            <div className="w-9 h-9 rounded-full bg-[#1a0647] text-white font-bold text-sm flex items-center justify-center shrink-0" data-id="element-4852" data-mp="2ucelr3awcxen">
              9
            </div>
            <h2 className="text-xl font-bold text-[#1a0647] leading-snug" data-id="element-4853" data-mp="342zsxf4mza96">
              Cookies and Tracking
            </h2>
          </div>
          <p className="text-[#555577] text-[15px] leading-[1.8] mb-3.5" data-id="element-4854" data-mp="26kg6k88buhw8">
            We use cookies and similar technologies to keep you logged in,
            remember your preferences, and collect analytics. You can control
            cookie settings through your browser. Disabling cookies may limit
            certain functionality on the platform.
          </p>
          <p className="text-[#555577] text-[15px] leading-[1.8] mb-0" data-id="element-4855" data-mp="1tip143b7iuig">
            We do not use cookies to track your activity outside of the Caveo
            platform.
          </p>
        </div>

        {/* Section 10 - Data Retention */}
        <div className="mb-12" data-id="element-4856" data-mp="15rt32og5r32r">
          <div className="flex items-center gap-3.5 mb-5 pb-3.5 border-b border-[#eae6dc]" data-id="element-4857" data-mp="15r06ggawxtyc">
            <div className="w-9 h-9 rounded-full bg-[#1a0647] text-white font-bold text-sm flex items-center justify-center shrink-0" data-id="element-4858" data-mp="1aqctp25p531g">
              10
            </div>
            <h2 className="text-xl font-bold text-[#1a0647] leading-snug" data-id="element-4859" data-mp="1fjfk51f6fwdf">
              Data Retention
            </h2>
          </div>
          <p className="text-[#555577] text-[15px] leading-[1.8] mb-0" data-id="element-4860" data-mp="n0ie4ctzt0di">
            We keep your personal information only as long as necessary to
            provide our services or as required by law. If you close your
            account, we will delete or anonymize your personal data within 90
            days, unless we are legally required to retain it longer.
          </p>
        </div>

        {/* Section 11 - Affiliate Disclosure (FTC-Compliant) */}
        <div className="mb-12" data-id="element-4861" data-mp="2hcpeno3euiop">
          <div className="flex items-center gap-3.5 mb-5 pb-3.5 border-b border-[#eae6dc]" data-id="element-4862" data-mp="2hcz4nboggpue">
            <div className="w-9 h-9 rounded-full bg-[#1a0647] text-white font-bold text-sm flex items-center justify-center shrink-0" data-id="element-4863" data-mp="2clh7yztgtbf8">
              11
            </div>
            <h2 className="text-xl font-bold text-[#1a0647] leading-snug" data-id="element-4864" data-mp="28i1doa4vbn5p">
              Affiliate Disclosure (FTC-Compliant)
            </h2>
          </div>
          <p className="text-[#555577] text-[15px] leading-[1.8] mb-3.5" data-id="element-4865" data-mp="1ykwoe1fq7bko">
            Some recommendations on the Caveo platform may include affiliate
            links. This means Caveo may earn a commission if you purchase a
            product or service through one of those links, at no additional cost
            to you. This is disclosed in compliance with FTC guidelines.
          </p>
          <div className="bg-gradient-to-br from-[#8528e2]/5 to-[#01ced1]/5 border border-[#8528e2]/15 rounded-xl p-5 md:p-6 my-4 text-[15px] text-[#555577] leading-[1.75]" data-id="element-4866" data-mp="1b05qlrt4kjup">
            <strong className="text-[#1a0647] font-semibold" data-id="element-4867" data-mp="22pqpjzs100d5">
              Our commitment to you:
            </strong>{' '}
            These commissions NEVER influence our recommendations. We repeat:
            They will NEVER influence our recommendations.
          </div>
          <p className="text-[#555577] text-[15px] leading-[1.8] mb-3.5" data-id="element-4868" data-mp="1xza9e7wtm0n3">
            All suggestions are based on our independent evaluation of what we
            believe will best serve your family's needs, devices, comfort level,
            and budget. We maintain the same recommendation integrity whether or
            not an affiliate relationship exists.
          </p>
          <p className="text-[#555577] text-[15px] leading-[1.8] mb-0" data-id="element-4869" data-mp="eyj9whznp0tz">
            When we recommend products like a router, a service provider, or a
            password manager, it's because they represent the best solution for
            your situation, not because they offer affiliate revenue.
          </p>
        </div>

        {/* Section 12 - Changes to This Policy */}
        <div className="mb-12" data-id="element-4870" data-mp="3s7e63720qfvo">
          <div className="flex items-center gap-3.5 mb-5 pb-3.5 border-b border-[#eae6dc]" data-id="element-4871" data-mp="3n82ndsi3d0bg">
            <div className="w-9 h-9 rounded-full bg-[#1a0647] text-white font-bold text-sm flex items-center justify-center shrink-0" data-id="element-4872" data-mp="3nafaek2pi0vd">
              12
            </div>
            <h2 className="text-xl font-bold text-[#1a0647] leading-snug" data-id="element-4873" data-mp="z9u3jfd48qj">
              Changes to This Policy
            </h2>
          </div>
          <p className="text-[#555577] text-[15px] leading-[1.8] mb-0" data-id="element-4874" data-mp="1cg9s8voe5hsh">
            We may update this Privacy Policy from time to time. When we do, we
            will revise the "Last Updated" date at the top of this page and, for
            significant changes, notify you by email or via an in-app
            notification. Your continued use of Caveo after changes take effect
            constitutes your acceptance of the updated policy.
          </p>
        </div>

        {/* Section 13 - Contact Us */}
        <div className="mb-12" data-id="element-4875" data-mp="4ya0qz31jmix">
          <div className="flex items-center gap-3.5 mb-5 pb-3.5 border-b border-[#eae6dc]" data-id="element-4876" data-mp="4x8r8z1ob83b">
            <div className="w-9 h-9 rounded-full bg-[#1a0647] text-white font-bold text-sm flex items-center justify-center shrink-0" data-id="element-4877" data-mp="9vjzj5cblajf">
              13
            </div>
            <h2 className="text-xl font-bold text-[#1a0647] leading-snug" data-id="element-4878" data-mp="ipopznnjkjyf">
              Contact Us
            </h2>
          </div>
          <p className="text-[#555577] text-[15px] leading-[1.8] mb-4" data-id="element-4879" data-mp="npt5pbgmlanl">
            If you have questions, concerns, or requests related to this Privacy
            Policy, please reach out:
          </p>

          <div className="bg-[#1a0647] rounded-xl p-7 md:p-10 mt-4" data-id="element-4880" data-mp="12sui9ua5etb3">
            <h3 className="text-lg font-bold text-white mb-4" data-id="element-4881" data-mp="xrx19l0vk5b6">
              AppEmbrace, Inc. d/b/a Caveo
            </h3>

            <div className="flex items-baseline gap-2.5 mb-2" data-id="element-4882" data-mp="stltdfu544vl">
              <span className="text-[12px] text-white/45 tracking-[0.08em] uppercase min-w-[70px]" data-id="element-4883" data-mp="os0drmq81chp">
                Attn
              </span>
              <span className="text-[15px] text-white/85" data-id="element-4884" data-mp="1lgziwsvidy5o">
                Jason Phillips, CEO
              </span>
            </div>

            <div className="flex items-baseline gap-2.5 mb-2" data-id="element-4885" data-mp="1bry4360p9mta">
              <span className="text-[12px] text-white/45 tracking-[0.08em] uppercase min-w-[70px]" data-id="element-4886" data-mp="1bq4xfqq372la">
                Email
              </span>
              <span className="text-[15px] text-white/85" data-id="element-4887" data-mp="2480inj4gdxqa">
                <a href="mailto:privacy@caveohq.com" className="text-[#b063ff] hover:underline" data-id="element-4888" data-mp="249jyj8m766rj">
                  privacy@caveohq.com
                </a>
              </span>
            </div>

            <div className="flex items-baseline gap-2.5 mb-2" data-id="element-4889" data-mp="2jmfxukbudc3">
              <span className="text-[12px] text-white/45 tracking-[0.08em] uppercase min-w-[70px]" data-id="element-4890" data-mp="2l619zkubekq">
                Website
              </span>
              <span className="text-[15px] text-white/85" data-id="element-4891" data-mp="3oxw2rz8lzdar">
                <a href="https://JoinCaveo.com" className="text-[#b063ff] hover:underline" data-id="element-4892" data-mp="3owb9se1y02f0">
                  JoinCaveo.com
                </a>
              </span>
            </div>

            <div className="flex items-baseline gap-2.5 mb-2" data-id="element-4893" data-mp="311ic3wzx6c5t">
              <span className="text-[12px] text-white/45 tracking-[0.08em] uppercase min-w-[70px]" data-id="element-4894" data-mp="31336nmm8hv3o">
                Location
              </span>
              <span className="text-[15px] text-white/85" data-id="element-4895" data-mp="zaf136m4avkq">
                Oakland, California
              </span>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="mt-16 pt-8 border-t border-[#eae6dc] text-center" data-id="element-4896" data-mp="2oppod4kwjeaw">
          <p className="text-[13px] text-[#aaaaaa] leading-[1.7]" data-id="element-4897" data-mp="2jreh91lzrhwd">
            &copy; 2026 AppEmbrace, Inc. d/b/a Caveo. All rights reserved.
          </p>
        </div>
      </div>
    </div>;
}